import TaskManagementBase from './TaskManagementBase';

export default function WeeklyProgress({ user }) {
  return (
    <TaskManagementBase
      user={user}
      moduleName="Weekly Progress"
      moduleTitle="Weekly Progress"
      moduleDescription="Weekly team updates, progress tracking, and status reports"
    />
  );
}
